<template>
  <Modal v-model="visible" width="600px" @on-cancel="onClose">
    <div class="emap-flow-elecseal-container">
      <Tabs v-model="curTab" :animated="false">
        <TabPane :label="$LocalH5('sealOrSign.chooseSeal')" name="elecseal" v-if="elecseal">
          <div class="elecseal-wrap" ref="elecsealWrapper">
            <div v-if="signatureType != '2'">
              <CheckboxGroup v-model="sealChecked">
                <Checkbox v-for="(item,key) in seals" :key="key" :label="item.WID" class="seal-item-box" :disabled="sealChecked.indexOf(item.WID) == -1 && isMultiple">
                  <div class="seal-img">
                    <img :src="item.url">
                  </div>
                  <div class="seal-label">{{item.NAME}}</div>
                </Checkbox>
              </CheckboxGroup>
            </div>
          </div>
        </TabPane>
        <TabPane :label="$LocalH5('sealOrSign.chooseSign')" name="signatrue" v-if="esignature">
          <div class="signature-wrap">
            <div class="instructions">
              <p>{{$LocalH5('sealOrSign.userDirections')}}:</p>
              <div>1、{{$LocalH5('sealOrSign.text1')}}</div>
              <div>2、{{$LocalH5('sealOrSign.click')}}<Icon type="md-refresh-circle" size=16 color="#2d8cf0" style="margin-top: 0px; margin-left: 0px;"/>{{$LocalH5('sealOrSign.text2')}}</div> 
              <div>3、{{$LocalH5('sealOrSign.text3')}}</div>
              <p style="margin-top:10px;">{{$LocalH5('sealOrSign.remark')}}:</p>
              <div>{{$LocalH5('sealOrSign.text4')}}</div> 
            </div>
            <div class="qrcode">
              <div :id="output" style="height: 154px;"></div>
              <p style="color: #808080;font-size: 12px;margin-top: 10px;" v-if="!qrcodeDisabled">{{$LocalH5('sealOrSign.text5')}}</p>
              <p style="color: #808080;font-size: 12px;margin-top: 10px;" v-if="qrcodeDisabled">
                <Icon type="ios-alert" color="#f90" style="margin-top: -2px;"/>{{$LocalH5('sealOrSign.text6')}}<a href="javascript:void(0)" @click="generateQRcode">{{$LocalH5('sealOrSign.refresh')}}</a>
              </p>
            </div>
            <div class="application">
              <Checkbox v-model="signatureChecked" :disabled="signDisabled">{{$LocalH5('sealOrSign.electSign')}}</Checkbox>
              <span class="signature-refresh" @click="refreshSignature">
                <Icon type="md-refresh-circle" size=24 color="#2d8cf0" style="margin-top: 0px; margin-left: 0px;" v-if="!signatureLoading"/>
                <span v-if="signatureLoading" style="display: inline-block;width: 20px;height:20px;background:#2d8cf0;border-radius:50%;text-align:center;margin-left:2px;">
                  <Icon type="ios-loading" size=12 color="#fff" class="signature-spin-icon-load"></Icon>
                </span>
              </span>
              <div class="signature">
                <img :src="signatureUrl + '&_=' + timestamp" v-if="signatureUrl"/>
              </div>
            </div>        
          </div>
        </TabPane>
      </Tabs>
    </div>
    <div slot="footer">
      <Button size="large" @click="onClose">{{$LocalH5('buttonCancel')}}</Button>
      <Button type="primary" size="large"  @click="okModel" :loading="loading" :disabled="btnDisabled">{{$LocalH5('buttonConfirm')}}</Button>
    </div>
  </Modal>
</template>

<script>
  import api from '@/api/comment'
  import { getContextPath, serialize, NewGuid } from 'utils'
  import QRcode from "utils/qrcode"
  const ContextPath = getContextPath();

  export default {
    name: "seal-modal", // 默认签章
    data() {
      return {
        visible: false,
        signatureChecked: false,
        curTab: 'elecseal',
        timestamp: '',
        output: NewGuid(),
        qrcodeDisabled: false,
        seals: [],
        signatureUrl: '',
        signatureLoading: false,
        loadSeal: ContextPath + "/sys/emapflow/elecseal/loadSeal.do",
        sealChecked: []
      }
    },
    props: {
      value: Boolean,
      loading: Boolean,
      elecseal: Boolean,
      esignature: Boolean,
      signatureType: [String, Number],
      chapterWID: String,
      multiple: Boolean,
      clip: Boolean,
      needElecseal: Boolean,
      needEsignature: Boolean,
    },
    watch: {
      value(val) {
        this.visible = val;
        if(val) {
          this.curTab = (!this.elecseal && this.esignature) || (!this.sealChecked.length && this.signatureChecked) ? 'signatrue' : 'elecseal'
          if(!this.seals.length) this.getSeals(true);
        }
      },
      visible(value) {
        this.$emit('input', value);
      },
      chapterWID(value) {
        this.sealChecked = [];
        this.signatureChecked = false;
        if(value) {
          this.sealChecked = [];
          this.seals.forEach(seal => {
            if(value.indexOf(seal.WID) > -1) {
              this.sealChecked.push(seal.WID);
            }
          });
          if(this.signatureUrl && value.indexOf(this.signatureUrl.slice(this.signatureUrl.indexOf('wid=') + 4)) > -1) {
            this.signatureChecked = true;
          }
        }
      },
      curTab(tab) {
        if(tab === 'signatrue') {
          this.generateQRcode();
          this.timestamp = new Date().getTime();
        }
      }
    },
    computed: {
      btnDisabled() {
        let state = false
        if (this.signatureType == 1) {
          if(this.elecseal && this.esignature) {
            state = !(!!this.sealChecked.length || this.signatureChecked)
          } else if (this.elecseal && !this.esignature) {
            state = !this.sealChecked.length
          } else if (!this.elecseal && this.esignature) {
            state = !this.signatureChecked
          }
        }
        return state
      },
      isMultiple() {
        if(this.multiple) {
          return this.sealChecked.length == ((this.esignature && this.signatureChecked) || (this.esignature && this.elecseal && this.needElecseal && this.needEsignature) ? 1:2)
        } else {
          return this.signatureChecked || this.sealChecked.length == 1
        }
      },
      signDisabled() {
        if(this.multiple) {
          return !this.signatureUrl || (this.elecseal && this.sealChecked.length == 2)
        } else {
          return !this.signatureUrl || (this.elecseal && this.sealChecked.length>0)
        }
      },
    },
    methods: {
      // 生成二维码
      generateQRcode() {
        api.getSignParam().then(data => {
          if(data && data.code === "0") {
            let params = data.datas.getMobileSignParam;
            if(this.clip) {
              params.clip = true
            }
            // var element = QRcode.createCanvas("http://172.20.7.242:8080/emap/sys/emapflow/tasks/queryFlowState.do?taskId=1362505&defKey=test_nextNode.eeFlow_20181102102137_wisedu");
            // YBT2-1159 二维码签名支持外网地址 wangyuan 2022-3-7
            let url = params.signatureQrCodeOutSchool ? params.signatureQrCodeOutSchool : window.location.origin 
            delete params.signatureQrCodeOutSchool
            let element = QRcode.createCanvas(url + ContextPath + "/sys/emapflow/elecsign/signature.html?" + serialize(params));
            // let element = QRcode.createCanvas(window.location.origin + ContextPath + "/sys/emapflow/elecsign/signature.html?" + serialize(params));
            let output = document.getElementById(this.output);
            output.innerText = "";   
            output.appendChild(element);
            this.qrcodeDisabled = false;
            if(this.timer) clearTimeout(self.timer);
            this.timer = setTimeout(() =>{
              this.qrcodeDisabled = true;
            },1000*5*60)
          }
        })
      },
      // 刷新签名
      refreshSignature() {
        this.signatureLoading = true;
        if(this.signatureUrl) {
          this.timestamp = new Date().getTime();
          const timer = setTimeout(() => {
            this.signatureLoading = false;
            clearTimeout(timer);
          },1000)
        } else {
          this.getSeals();
        }
      },
      getSeals(init) {
        this.seals = [];
        this.sealChecked = [];
        api.getSeals().then(data => {
          if(this.signatureLoading) this.signatureLoading = false;
          if(data.code == '0'){
            let rows = data.datas.queryMySeals.rows;
            rows.forEach(row => {
              if(row.STYPE === "0") {
                if(this.chapterWID.indexOf(row.WID) > -1) {
                  this.sealChecked.push(row.WID)
                }
                row.url = this.loadSeal + "?wid=" + row.WID;
                this.seals.push(row);
              } else if(row.STYPE === "1") {
                this.signatureUrl = this.loadSeal + '?wid=' + row.WID
                this.signatureChecked = this.chapterWID.indexOf(row.WID) > -1;
              }
            });
            if(init) this.curTab = (!this.elecseal && this.esignature) || (!this.sealChecked.length && this.signatureChecked) ? 'signatrue' : 'elecseal';
          } else {
            this.$Message.error(data.msg);
          }
        })
      },
      // 关闭
      onClose() {
        if (this.loading) {
          return
        }
        this.visible = false;
        if(this.esignature) {
          const output = document.getElementById(this.output);
          if(!output) 
          output.innerText = "";
        }
        this.$emit('on-close')
      },
      // 确认
      okModel() {
        let wids = [], urls =[];
        // 处理印章
        if(this.elecseal && this.sealChecked.length) {
          this.seals.forEach(seal => {
            if(this.sealChecked.indexOf(seal.WID) > -1) {
              wids.push(seal.WID);
              urls.push(seal.url);
            }
          });
        }
        // 处理签名
        if(this.esignature && this.signatureChecked) {
          wids.push(this.signatureUrl.slice(this.signatureUrl.indexOf('wid=') + 4));
          urls.push(this.signatureUrl + "&_=" + new Date().getTime());
        }
        this.$emit('on-confirm', wids, urls);
      },
      resetSeal(name) {
        if(name == 'elecseal') {
          this.sealChecked = [];
        } else if(name == 'signatrue') {
          this.signatureChecked = false;
        } else {
          this.sealChecked = [];
          this.signatureChecked = false;
        }
      }
    },
    mounted() {
      // ...
    }
  };
</script>
<style scoped>
  .elecseal-wrap {
    height: 310px;
    overflow-y: auto;
  }
  .elecseal-wrap:after {
    display: block;
    content: '';
    clear: both;
  }
  .instructions {
    float: left;
    width: calc(100% - 370px);
    padding: 10px 0;
    font-size: 12px;
    font-weight: 500;
  }
  .instructions p {
    margin-bottom: 10px;
    font-size: 14px;
  }
  .qrcode {
    float: left;
    width: 220px;
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .signature-wrap:after {
    content: "";
    display: table;
    clear: both;
  }
  .application {
    float: left;
    width: 150px;
    height: 200px;
  }
  .application label {
    margin: 20px 0;
  }
  .signature img {
    display: block;
    max-height: 100%;
    max-width: 100%;
    margin: 0 auto;
  }
  .signature-refresh {
    margin: 0 4px;
    cursor: pointer;
  }
  .signature-spin-icon-load{
    animation: loading-spin 1s linear infinite;
    margin-top: -2px;
  }
  @keyframes loading-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .seal-img, .signature {
    height: 100px;
    width: 100px;
    border: 1px solid #dddee1;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .seal-img img{
    display: block;
    max-height: 100%;
    max-width: 100%;
  }
  .seal-item-box {
    position: relative;
    width: 100px;
  }
  .seal-item-box >>> .ivu-checkbox {
    position: absolute;
    top: 108px;
  }
  .seal-label {
    margin: 8px 0 10px 20px;
    line-height: 16px;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 32px;
    white-space: unset;
  }
</style>